import { useTranslation } from "react-i18next";
import ChartNoData from "components/charting/ChartNoData";

function OneRepMaxChartNoDataPeriod() {
  const { t } = useTranslation();

  return (
    <ChartNoData
      title={t("charting.one_rep_max_no_data_period_title")}
      description={t("charting.one_rep_max_no_data_period_description")}
    />
  );
}

export default OneRepMaxChartNoDataPeriod;
